import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20atmosphere%2C%20dramatic%20film%20reel%20and%20projector%20light%20beams%20in%20darkness%2C%20elegant%20velvet%20curtains%2C%20warm%20golden%20spotlight%2C%20luxurious%20cinema%20interior%2C%20moody%20atmospheric%20lighting%2C%20deep%20blacks%20with%20amber%20accents%2C%20artistic%20abstract%20cinematic%20composition&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="8090影视 - 电影大全平台"
          title="8090影视电影大全 - 最新电影与经典电影高清在线观看"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-cinema-black/70 via-cinema-black/50 to-cinema-black" />
        <div className="absolute inset-0 bg-gradient-to-r from-cinema-black/50 via-transparent to-cinema-black/50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="animate-fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-cinema-gold/10 border border-cinema-gold/20 mb-6">
              <i className="ri-fire-line text-cinema-gold text-sm"></i>
              <span className="text-cinema-gold text-xs font-medium">海量高清片库 · 流畅在线观影</span>
            </div>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-fade-in-up">
            电影<span className="text-cinema-gold">大全</span>
            <br />
            <span className="text-2xl md:text-3xl lg:text-4xl font-normal">最新电影与经典电影</span>
          </h1>

          <p className="text-cinema-text-dim text-base md:text-lg max-w-2xl mx-auto mb-10 animate-fade-in-up leading-relaxed">
            8090影视聚合华语电影、欧美电影、日韩电影等海量影片资源，高清画质流畅播放，给热爱电影的你最好的观影体验
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slide-up">
            <Link
              to="/category/zuixin"
              className="w-full sm:w-auto px-8 py-3.5 bg-cinema-gold text-cinema-black font-semibold rounded-full hover:bg-cinema-gold-light transition-all duration-300 whitespace-nowrap text-sm cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观影
            </Link>
            <Link
              to="/category/gaofen"
              className="w-full sm:w-auto px-8 py-3.5 border border-cinema-border text-white rounded-full hover:border-cinema-gold hover:text-cinema-gold transition-all duration-300 whitespace-nowrap text-sm cursor-pointer"
            >
              <i className="ri-star-line mr-2"></i>
              高分推荐
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-14 animate-fade-in">
            {[
              { value: '20,000+', label: '电影资源' },
              { value: '98%', label: '高清画质' },
              { value: '500万+', label: '观影用户' },
              { value: '4.8', label: '用户评分' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-cinema-gold font-heading">{stat.value}</div>
                <div className="text-cinema-text-dim text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}